import { api } from "@/lib/api/client";

/** Un type d'enregistrement emporté par la cascade, avec son décompte. */
export interface CascadeItem {
  type: string;
  label: string;
  label_plural: string;
  count: number;
}

export interface DeletionPreview {
  target_type: string;
  target_id: string;
  target_label: string;
  target_name: string;
  /** Dépendances qui bloquent la suppression ordinaire. */
  blockers: string[];
  total: number;
  items: CascadeItem[];
  /** Conséquences qu'un décompte ne dit pas (recettes, numérotation…). */
  warnings: string[];
  /** Autorité du serveur : le compte courant a-t-il droit à la cascade ? */
  can_cascade: boolean;
}

/**
 * Ressources sur lesquelles la cascade est ouverte. Liste fermée, alignée sur
 * les viewsets qui exposent `deletion-preview` côté back : une URL absente
 * d'ici n'est jamais sondée. `products` en est volontairement exclu (ADR 0015).
 */
export const CASCADE_RESOURCES = [
  "patients",
  "clients",
  "consultations",
  "treasury-accounts",
  "insurances",
  "patient-insurances",
] as const;

export type CascadeResource = (typeof CASCADE_RESOURCES)[number];

export const fetchDeletionPreview = (resource: string, id: string) =>
  api
    .get<DeletionPreview>(`/${resource}/${id}/deletion-preview/`)
    .then((r) => r.data);

export const cascadeDelete = (resource: string, id: string) =>
  api.delete(`/${resource}/${id}/`, { params: { cascade: 1 } });
